<template>
    <div class="modal fade" id="tableColumnSelectionLatestModal" tabindex="-1" role="dialog" aria-labelledby="tableColumnSelectionLatestLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header bg-followup-nav text-white">
                    <h5 class="modal-title px-2 font-semibold" id="tableColumnSelectionLatestLabel">Edit columns</h5>
                    <button type="button" class="close" aria-label="Close" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- Modal Content -->
                <div class="modal-body px-4">
                    <div class="row">
                        <div class="col-md-5 border-right">
                            <!-- Search Columns -->
                            <div class="search-column-container">
                                <input v-model="searchText"
                                       type="text"
                                       class="form-control focus:border-followup-nav"
                                       placeholder="Search columns...">
                                <i class="fa fa-search text-primary"></i>
                            </div>

                            <!-- All Columns List -->
                            <div class="py-3 overflow-auto">
                                <div v-for="column in filteredObj" :key="column.property_name">
                                    <label class="custom-column-checkbox">
                                        <input type="checkbox"
                                               :id="`checkbox-${column.property_name}`"
                                               :checked="columns.some(col => col.property_name === column.property_name)"
                                               @change="toggleColumnSelection(column)"/>
                                        <span class="checkmark"></span>
                                        <label :for="`checkbox-${column.property_name}`" class="m-0 pointer text-grey-darkest">{{ column.name }}</label>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Draggable Columns -->
                        <div class="col-md-7">
                            <div class="list-group overflow-auto" style="height: 410px;">
                                <Container @drop="onDrop" drag-class="opacity-ghost" drop-class="opacity-ghost-drop" :get-ghost-parent="getGhostParent">
                                    <Draggable v-for="(column, index) in columns" :key="column.property_name">
                                        <div v-if="getIndexOfFreezeColumn(columns) === 0 && index === 0" class="d-flex align-items-center justify-content-between list-group-item-custom text-grey-dark">
                                            Drag Columns Here
                                        </div>

                                        <!-- Freeze Columns Partition -->
                                        <div v-if="column.property_name === 'freeze_column'"
                                             key="frozen-column"
                                             class="d-flex align-items-center justify-content-center freeze-column py-3">
                                            <span>Above columns are frozen</span>
                                            <i class="fa fa-info-circle text-grey ml-1"
                                               data-toggle="tooltip"
                                               data-placement="top"
                                               data-boundary="viewport"
                                               title="Limit of 3 frozen columns">
                                            </i>
                                        </div>

                                        <!-- Columns -->
                                        <div v-else class="draggable-item d-flex align-items-center justify-content-between list-group-item text-grey-darkest">
                                            <div class="d-flex align-items-center">
                                                <div class="d-flex align-items-center">
                                                    <span class="material-icons">drag_indicator</span>
                                                    <span>{{ column.name }}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <div>
                                                    <button @click="removeColumn(index)" class="no-btn-properties text-grey-dark float-right">×</button>
                                                </div>
                                            </div>
                                        </div>
                                    </Draggable>
                                </Container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="mr-auto">
                        <button @click="applyColumns"
                                :disabled="columns.length <= 1"
                                type="button"
                                class="btn btn-primary">Apply</button>
                        <button type="button" class="btn btn-secondary" @click="close">Cancel</button>
                        <button @click="removeAllColumns" type="button" class="btn btn-link">Remove all columns</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";
const freezeColumnObject = {name: 'Freeze Column', property_name: 'freeze_column'};
export default {
    name: 'table-column-selection-latest',
    props: ['tableColumns', 'noOfFrozenColumns', 'userListDefaultColumns'],
    components: { Container, Draggable },
    data() {
        return {
            drag: false,
            columns: [],
            searchText: "",
        }
    },
    watch: {
        tableColumns: {
            handler: function(val, oldVal) {
                this.manageTableColumnsData();
            }
        }
    },
    computed: {
        filteredObj() {
            const result = this.searchText.trim()
                ? this.userListDefaultColumns.filter(item =>
                    item.name.toLowerCase().includes(this.searchText.toLowerCase())
                )
                : this.userListDefaultColumns;

            return _.sortBy(result, ['name']);
        }
    },
    mounted() {
        this.manageTooltip();
    },
    methods: {
        open() {
            $("#tableColumnSelectionLatestModal").modal("show");
        },
        close() {
            this.searchText = "";
            this.manageTableColumnsData();
            $("#tableColumnSelectionLatestModal").modal("hide");
        },
        getGhostParent() {
            return document.body;
        },
        onDrop(dropResult) {
            const { removedIndex, addedIndex, payload } = dropResult
            if (removedIndex === null && addedIndex === null) return this.columns

            const result = [...this.columns];
            const oldColumns = [...this.columns];
            let itemToAdd = payload

            if(removedIndex !== null) {
                itemToAdd = result.splice(removedIndex, 1)[0]
            }

            if(addedIndex !== null) {
                result.splice(addedIndex, 0, itemToAdd)
            }

            const freezeColumnIndex = this.getIndexOfFreezeColumn(result);

            if(freezeColumnIndex < 4) {
                this.columns = result;
            }
            else {
                this.columns = oldColumns;
            }
        },
        applyColumns() {
            this.$emit('saveColumnState', this.columns);
            $("#tableColumnSelectionLatestModal").modal("hide");
        },
        manageTooltip() {
            const tooltipSelector = $('[data-toggle="tooltip"]');

            tooltipSelector.tooltip({
                trigger: 'hover'
            });
        },
        removeAllColumns() {
            this.columns = [];
            this.columns.push(_.cloneDeep(freezeColumnObject));
        },
        toggleColumnSelection(column) {
            const index = this.columns.findIndex(col => col.property_name === column.property_name);

            if(index !== -1) {
                this.removeColumn(index);
            }
            else {
                this.columns.push(column);
            }
        },
        removeColumn(index) {
            this.columns.splice(index, 1);
        },
        getIndexOfFreezeColumn(columns) {
            return _.findIndex(columns, { property_name: "freeze_column" });
        },
        manageTableColumnsData() {
            this.columns = _.cloneDeep(this.tableColumns);
            this.columns.splice(this.noOfFrozenColumns, 0, _.cloneDeep(freezeColumnObject))
        }
    }
}
</script>

<style scoped>
.search-column-container {
    position: relative;
}
.search-column-container i {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
}
.custom-column-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    user-select: none;
    gap: 8px;
}
.custom-column-checkbox input[type="checkbox"] {
    display: none;
}
.custom-column-checkbox .checkmark {
    width: 20px;
    height: 20px;
    background-color: #fff;
    border: 2px solid #01B1AF;
    border-radius: 4px;
    display: inline-block;
    position: relative;
    transition: background-color 0.3s, border-color 0.3s;
}
.custom-column-checkbox input[type="checkbox"]:checked + .checkmark {
    background-color: #01B1AF;
    border-color: #01B1AF;
}
.custom-column-checkbox input[type="checkbox"]:checked + .checkmark::after {
    content: '';
    position: absolute;
    top: 44%;
    left: 50%;
    width: 7px;
    height: 12px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    transform: translate(-50%, -50%) rotate(45deg);
}
.freeze-column {
    display: flex;
    align-items: center;
    text-align: center;
    color: #6c757d; /* Bootstrap muted text color */
    font-weight: bold;
    font-size: 14px;
}
.freeze-column::before,
.freeze-column::after {
    content: "";
    flex: 1;
    border-bottom: 2px solid #6c757d;
    margin: 0 10px;
}
.list-group-item {
    background-color: #e7ebef;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 8px;
    cursor: grab;
    border: 1px solid #d1d5db;
}
.list-group-item-custom {
    background-color: #e7ebef;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 8px;
    border: 1px dashed;
    pointer-events: none;
}
.no-link-properties {
    text-decoration: none;
    cursor: pointer;
}
.draggable-item {
    border: 1px solid rgba(0, 0, 0, .125);
    cursor: move;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
}
.draggable-item .custom-control{
    margin-left: 10px !important;
}
.dragging {
    background-color: yellow;
}
.opacity-ghost {
    transition: all .18s ease;
    opacity: 0.8;
    /* transform: rotateZ(5deg); */
    background-color: cornflowerblue;
    box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.3);
}
.opacity-ghost-drop {
    opacity: 1;
    /* transform: rotateZ(0deg); */
    background-color: white;
    box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.0);
}
.cards-drop-preview {
    background-color: rgba(150, 150, 200, 0.1);
    border: 1px dashed #abc;
    margin: 5px 45px 5px 5px;
}
.smooth-dnd-ghost{
    z-index: 1100 !important;
}
.filter-popover-class {
    .popover-body {
        height: auto !important;
        padding: 0 !important;
    }
}
.hover\:theme-custom-background:hover {
    background-color: #01b1af2e;
}
.hover\:theme-custom-color:hover {
    color: #49545a;
}
.material-icons {
    font-size: 18px;
}
</style>
